import type { OrigemDaFigurinha } from "@foto/shared";

/** Peso em linguagem de gente: "312 KB", "1,4 MB". */
export function pesoLegivel(bytes: number): string {
  if (bytes < 1024) return `${bytes} bytes`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1).replace(".", ",")} MB`;
}

/** "1024 × 768 px". */
export function dimensoesLegiveis(largura: number, altura: number): string {
  return `${largura} × ${altura} px`;
}

export const ROTULO_DA_ORIGEM: Record<OrigemDaFigurinha, string> = {
  upload: "Enviada por arquivo",
  ia: "Criada por IA",
};

/**
 * "3 de out. de 2026, 14:22". Com o ano, ao contrário do `dataHora` das listas: a biblioteca guarda
 * imagens por meses, e "03/10" sozinho não diz de que ano é.
 *
 * `fusoHorario` existe para o teste não depender da máquina em que roda; na tela fica o do aparelho.
 */
export function dataDaImagem(iso: string, fusoHorario?: string): string {
  const data = new Date(iso);
  if (Number.isNaN(data.getTime())) return "—";
  return new Intl.DateTimeFormat("pt-BR", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    ...(fusoHorario && { timeZone: fusoHorario }),
  }).format(data);
}

/**
 * "123 de 1000". Conta como o servidor (`z.string().max()`: unidades UTF-16), para o contador nunca
 * dizer que cabe o que o servidor vai recusar.
 */
export function contadorDeLetras(texto: string, maximo: number): string {
  return `${texto.length} de ${maximo}`;
}

/** O teto de imagens que a tela pede de uma vez: o padrão do servidor (`listarFigurinhasSchema`). */
export const LIMITE_DA_LISTA = 300;

/**
 * "12 imagens", e, quando a lista bateu no teto, o aviso de que há mais — sem ele a pessoa acharia que a
 * biblioteca acaba ali, e procuraria no lugar errado o que está só mais para trás.
 */
export function contagemDeImagens(quantas: number, limite = LIMITE_DA_LISTA): string {
  if (quantas === 0) return "Nenhuma imagem";
  if (quantas >= limite) {
    return `As ${quantas} mais novas. Use a busca para achar as outras.`;
  }
  return quantas === 1 ? "1 imagem" : `${quantas} imagens`;
}

/** O nome que o servidor daria a uma imagem enviada sem nome: o do arquivo, sem a extensão. */
export function nomeSugerido(nomeDoArquivo: string, maximo: number): string {
  return nomeDoArquivo
    .replace(/\.[^.]+$/, "")
    .trim()
    .slice(0, maximo);
}
